import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=23a4ceea&scoped=true"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=23a4ceea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4ceea",
  null
  
)

export default component.exports